var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#118772"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8525 17.5492L18.9992 17.6967L19.1475 17.5492C19.3216 17.375 19.5283 17.2369 19.7558 17.1427C19.9833 17.0485 20.2271 17 20.4734 17C20.7196 17 20.9634 17.0485 21.1909 17.1427C21.4184 17.2369 21.6251 17.375 21.7992 17.5492C21.9733 17.7233 22.1114 17.93 22.2056 18.1575C22.2999 18.3849 22.3484 18.6288 22.3484 18.875C22.3484 19.1212 22.2999 19.365 22.2056 19.5925C22.1114 19.82 21.9733 20.0267 21.7992 20.2008L18.9992 23L16.2009 20.2008C15.8492 19.8492 15.6517 19.3723 15.6517 18.875C15.6517 18.3777 15.8492 17.9008 16.2009 17.5492C16.5525 17.1975 17.0294 17 17.5267 17C18.024 17 18.5009 17.1975 18.8525 17.5492ZM13.985 16.1667V17.8333C12.6589 17.8333 11.3872 18.3601 10.4495 19.2978C9.51181 20.2355 8.98503 21.5072 8.98503 22.8333H7.31836C7.31838 21.1013 7.99247 19.4373 9.19792 18.1936C10.4034 16.9499 12.0455 16.2241 13.7767 16.17L13.985 16.1667ZM13.985 5.33333C16.7475 5.33333 18.985 7.57083 18.985 10.3333C18.9855 11.6271 18.4843 12.8707 17.5868 13.8025C16.6893 14.7344 15.4654 15.2819 14.1725 15.33L13.985 15.3333C11.2225 15.3333 8.98503 13.0958 8.98503 10.3333C8.98456 9.03955 9.48578 7.796 10.3833 6.86415C11.2808 5.9323 12.5046 5.38476 13.7975 5.33666L13.985 5.33333ZM13.985 6.99999C12.1434 6.99999 10.6517 8.49166 10.6517 10.3333C10.6517 12.175 12.1434 13.6667 13.985 13.6667C15.8267 13.6667 17.3184 12.175 17.3184 10.3333C17.3184 8.49166 15.8267 6.99999 13.985 6.99999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/Partner.7764518dd7215f52c64359595070d937.svg";
export { ForwardRef as ReactComponent };